// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c2bf34d7","890":"e638228c"}[chunkId] + ".chunk.js";
};